const routes = [
  {
    path: '/user',
    name: 'User',
    component: () => import(/* webpackChunkName: "user" */ '@/views/user/UserMain'),
    children: [
      {
        path: 'list',
        alias: '',
        name: 'UserList',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/UserList'),
        prop: true,
        meta: {
          step: ['운전자 설정', '운전자 설정 리스트(User)']
        }
      },
      {
        path: ':seq(\\d+)',
        name: 'UserView',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/UserView'),
        prop: true,
        meta: {
          step: ['운전자 설정', '운전자 설정 세부(User)']
        }
      },
      {
        path: 'write',
        name: 'UserWrite',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/UserView'),
        prop: true,
        meta: {
          step: ['운전자 설정', '운전자 설정 등록(User)']
        }
      }
    ]
  }
]

export default routes
